var $jvNZe$emotionreactjsxruntime = require("@emotion/react/jsx-runtime");
var $jvNZe$react = require("react");
var $jvNZe$emotionreact = require("@emotion/react");
var $jvNZe$reactintersectionobserver = require("react-intersection-observer");
var $jvNZe$reactis = require("react-is");

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}
function $parcel$exportWildcard(dest, source) {
  Object.keys(source).forEach(function(key) {
    if (key === 'default' || key === '__esModule' || dest.hasOwnProperty(key)) {
      return;
    }

    Object.defineProperty(dest, key, {
      enumerable: true,
      get: function get() {
        return source[key];
      }
    });
  });

  return dest;
}

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $c8a4d927fd00b892$export$9a32a8eb4bb56ca3);
var $b60c6d4b91d2d5a9$exports = {};
var $53b8ad22b050830b$exports = {};

$parcel$export($53b8ad22b050830b$exports, "AttentionSeeker", () => $53b8ad22b050830b$export$1736648c5c27c79d);



const $88ffd68ae302398a$export$e3ce947fb98643bf = (0, $jvNZe$emotionreact.keyframes)`
  from,
  20%,
  53%,
  to {
    animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
    transform: translate3d(0, 0, 0);
  }

  40%,
  43% {
    animation-timing-function: cubic-bezier(0.755, 0.05, 0.855, 0.06);
    transform: translate3d(0, -30px, 0) scaleY(1.1);
  }

  70% {
    animation-timing-function: cubic-bezier(0.755, 0.05, 0.855, 0.06);
    transform: translate3d(0, -15px, 0) scaleY(1.05);
  }

  80% {
    transition-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
    transform: translate3d(0, 0, 0) scaleY(0.95);
  }

  90% {
    transform: translate3d(0, -4px, 0) scaleY(1.02);
  }
`;


const $fd9067391ce6df13$export$fff9462e59a6c087 = (0, $jvNZe$emotionreact.keyframes)`
  from,
  50%,
  to {
    opacity: 1;
  }

  25%,
  75% {
    opacity: 0;
  }
`;


const $eb9167f8b04a1eef$export$cc718fa79617014c = (0, $jvNZe$emotionreact.keyframes)`
  0% {
    transform: translateX(0);
  }

  6.5% {
    transform: translateX(-6px) rotateY(-9deg);
  }

  18.5% {
    transform: translateX(5px) rotateY(7deg);
  }

  31.5% {
    transform: translateX(-3px) rotateY(-5deg);
  }

  43.5% {
    transform: translateX(2px) rotateY(3deg);
  }

  50% {
    transform: translateX(0);
  }
`;


const $6efeb5b76066380c$export$f5767cd4e86f63a5 = (0, $jvNZe$emotionreact.keyframes)`
  0% {
    transform: scale(1);
  }

  14% {
    transform: scale(1.3);
  }

  28% {
    transform: scale(1);
  }

  42% {
    transform: scale(1.3);
  }

  70% {
    transform: scale(1);
  }
`;


const $bbf7c8c1f2f8bcda$export$821f6a9282d0ec8d = (0, $jvNZe$emotionreact.keyframes)`
  from,
  11.1%,
  to {
    transform: translate3d(0, 0, 0);
  }

  22.2% {
    transform: skewX(-12.5deg) skewY(-12.5deg);
  }

  33.3% {
    transform: skewX(6.25deg) skewY(6.25deg);
  }

  44.4% {
    transform: skewX(-3.125deg) skewY(-3.125deg);
  }

  55.5% {
    transform: skewX(1.5625deg) skewY(1.5625deg);
  }

  66.6% {
    transform: skewX(-0.78125deg) skewY(-0.78125deg);
  }

  77.7% {
    transform: skewX(0.390625deg) skewY(0.390625deg);
  }

  88.8% {
    transform: skewX(-0.1953125deg) skewY(-0.1953125deg);
  }
`;


const $409347824bf28b80$export$f3aaf94dc96a60de = (0, $jvNZe$emotionreact.keyframes)`
  from {
    transform: scale3d(1, 1, 1);
  }

  50% {
    transform: scale3d(1.05, 1.05, 1.05);
  }

  to {
    transform: scale3d(1, 1, 1);
  }
`;


const $118273709ecc7996$export$bbc07f6a19d55e88 = (0, $jvNZe$emotionreact.keyframes)`
  from {
    transform: scale3d(1, 1, 1);
  }

  30% {
    transform: scale3d(1.25, 0.75, 1);
  }

  40% {
    transform: scale3d(0.75, 1.25, 1);
  }

  50% {
    transform: scale3d(1.15, 0.85, 1);
  }

  65% {
    transform: scale3d(0.95, 1.05, 1);
  }

  75% {
    transform: scale3d(1.05, 0.95, 1);
  }

  to {
    transform: scale3d(1, 1, 1);
  }
`;


const $99597785e49dcbea$export$267b06a7460aa7d3 = (0, $jvNZe$emotionreact.keyframes)`
  from,
  to {
    transform: translate3d(0, 0, 0);
  }

  10%,
  30%,
  50%,
  70%,
  90% {
    transform: translate3d(-10px, 0, 0);
  }

  20%,
  40%,
  60%,
  80% {
    transform: translate3d(10px, 0, 0);
  }
`;


const $5dd42df0435d852f$export$8e99d6962f95c405 = (0, $jvNZe$emotionreact.keyframes)`
  from,
  to {
    transform: translate3d(0, 0, 0);
  }

  10%,
  30%,
  50%,
  70%,
  90% {
    transform: translate3d(-10px, 0, 0);
  }

  20%,
  40%,
  60%,
  80% {
    transform: translate3d(10px, 0, 0);
  }
`;


const $ef91eb5bdfc318f0$export$8c0595fc0dd256ce = (0, $jvNZe$emotionreact.keyframes)`
  from,
  to {
    transform: translate3d(0, 0, 0);
  }

  10%,
  30%,
  50%,
  70%,
  90% {
    transform: translate3d(0, -10px, 0);
  }

  20%,
  40%,
  60%,
  80% {
    transform: translate3d(0, 10px, 0);
  }
`;


const $17cad7ed79df0fbf$export$84fc4030631e573c = (0, $jvNZe$emotionreact.keyframes)`
  20% {
    transform: rotate3d(0, 0, 1, 15deg);
  }

  40% {
    transform: rotate3d(0, 0, 1, -10deg);
  }

  60% {
    transform: rotate3d(0, 0, 1, 5deg);
  }

  80% {
    transform: rotate3d(0, 0, 1, -5deg);
  }

  to {
    transform: rotate3d(0, 0, 1, 0deg);
  }
`;


const $cb5eed64c434fe13$export$1362d96c12095304 = (0, $jvNZe$emotionreact.keyframes)`
  from {
    transform: scale3d(1, 1, 1);
  }

  10%,
  20% {
    transform: scale3d(0.9, 0.9, 0.9) rotate3d(0, 0, 1, -3deg);
  }

  30%,
  50%,
  70%,
  90% {
    transform: scale3d(1.1, 1.1, 1.1) rotate3d(0, 0, 1, 3deg);
  }

  40%,
  60%,
  80% {
    transform: scale3d(1.1, 1.1, 1.1) rotate3d(0, 0, 1, -3deg);
  }

  to {
    transform: scale3d(1, 1, 1);
  }
`;


const $64e244b1100f4aec$export$138a91d3335be56 = (0, $jvNZe$emotionreact.keyframes)`
  from {
    transform: translate3d(0, 0, 0);
  }

  15% {
    transform: translate3d(-25%, 0, 0) rotate3d(0, 0, 1, -5deg);
  }

  30% {
    transform: translate3d(20%, 0, 0) rotate3d(0, 0, 1, 3deg);
  }

  45% {
    transform: translate3d(-15%, 0, 0) rotate3d(0, 0, 1, -3deg);
  }

  60% {
    transform: translate3d(10%, 0, 0) rotate3d(0, 0, 1, 2deg);
  }

  75% {
    transform: translate3d(-5%, 0, 0) rotate3d(0, 0, 1, -1deg);
  }

  to {
    transform: translate3d(0, 0, 0);
  }
`;



var $c8a4d927fd00b892$exports = {};

$parcel$export($c8a4d927fd00b892$exports, "Reveal", () => $c8a4d927fd00b892$export$9a32a8eb4bb56ca3);






const $9ea0f43f56ccecde$export$82e6205b15e6c637 = (0, $jvNZe$emotionreact.keyframes)`
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
`;


const $5d24f5d06eb0ca64$export$27e0c58916e1badc = (0, $jvNZe$emotionreact.keyframes)`
  from {
    opacity: 0;
    transform: translate3d(-100%, 100%, 0);
  }

  to {
    opacity: 1;
    transform: translate3d(0, 0, 0);
  }
`;


const $2a57c406215d34eb$export$f72096766ea3a089 = (0, $jvNZe$emotionreact.keyframes)`
  from {
    opacity: 0;
    transform: translate3d(100%, 100%, 0);
  }

  to {
    opacity: 1;
    transform: translate3d(0, 0, 0);
  }
`;


const $568a146f8f1dc468$export$6ecdcdb0033d0327 = (0, $jvNZe$emotionreact.keyframes)`
  from {
    opacity: 0;
    transform: translate3d(0, -100%, 0);
  }

  to {
    opacity: 1;
    transform: translate3d(0, 0, 0);
  }
`;


const $993b4f2eec647e23$export$aa45f1f50300a7c0 = (0, $jvNZe$emotionreact.keyframes)`
  from {
    opacity: 0;
    transform: translate3d(0, -2000px, 0);
  }

  to {
    opacity: 1;
    transform: translate3d(0, 0, 0);
  }
`;


const $059dd4d1a0e7c5c8$export$d8fce5eeb232a07b = (0, $jvNZe$emotionreact.keyframes)`
  from {
    opacity: 0;
    transform: translate3d(-100%, 0, 0);
  }

  to {
    opacity: 1;
    transform: translate3d(0, 0, 0);
  }
`;


const $e77687a7cf911846$export$327c6b58e5f59d6f = (0, $jvNZe$emotionreact.keyframes)`
  from {
    opacity: 0;
    transform: translate3d(-2000px, 0, 0);
  }

  to {
    opacity: 1;
    transform: translate3d(0, 0, 0);
  }
`;


const $f128273212bfa795$export$7b78ca149b3ffe20 = (0, $jvNZe$emotionreact.keyframes)`
  from {
    opacity: 0;
    transform: translate3d(100%, 0, 0);
  }

  to {
    opacity: 1;
    transform: translate3d(0, 0, 0);
  }
`;


const $55cf3d076c695f42$export$6f5ccd79656f671 = (0, $jvNZe$emotionreact.keyframes)`
  from {
    opacity: 0;
    transform: translate3d(2000px, 0, 0);
  }

  to {
    opacity: 1;
    transform: translate3d(0, 0, 0);
  }
`;


const $156b763c5e69a9ca$export$777354dbc7828ff3 = (0, $jvNZe$emotionreact.keyframes)`
  from {
    opacity: 0;
    transform: translate3d(-100%, -100%, 0);
  }

  to {
    opacity: 1;
    transform: translate3d(0, 0, 0);
  }
`;


const $694098d2b7aee85e$export$d5bfa04a6ce7104f = (0, $jvNZe$emotionreact.keyframes)`
  from {
    opacity: 0;
    transform: translate3d(100%, -100%, 0);
  }

  to {
    opacity: 1;
    transform: translate3d(0, 0, 0);
  }
`;


const $b15cf9ee005e2158$export$546bb2e31f381a81 = (0, $jvNZe$emotionreact.keyframes)`
  from {
    opacity: 0;
    transform: translate3d(0, 100%, 0);
  }

  to {
    opacity: 1;
    transform: translate3d(0, 0, 0);
  }
`;


const $0cf1b8b22f8c2075$export$f18a2356a26ed325 = (0, $jvNZe$emotionreact.keyframes)`
  from {
    opacity: 0;
    transform: translate3d(0, 2000px, 0);
  }

  to {
    opacity: 1;
    transform: translate3d(0, 0, 0);
  }
`;





function $f2597d38a334a0ad$export$cdf1f51c52cf49d8({ duration: duration = 1000 , delay: delay = 0 , timingFunction: timingFunction = "ease" , keyframes: keyframes = (0, $059dd4d1a0e7c5c8$export$d8fce5eeb232a07b) , iterationCount: iterationCount = 1 ,  }) {
    return (0, $jvNZe$emotionreact.css)`
    animation-duration: ${duration}ms;
    animation-timing-function: ${timingFunction};
    animation-delay: ${delay}ms;
    animation-name: ${keyframes};
    animation-direction: normal;
    animation-fill-mode: both;
    animation-iteration-count: ${iterationCount};
  `;
}


function $6a26e8abc0402dd5$export$bedb7023a7733221(value) {
    return value === null || value === undefined;
}
function $6a26e8abc0402dd5$export$f832f653c73e86f8(value) {
    return typeof value === "string" || typeof value === "number" || typeof value === "boolean";
}


const $c8a4d927fd00b892$var$hiddenStyles = (0, $jvNZe$emotionreact.css)`
  opacity: 0;
`;
const $c8a4d927fd00b892$var$textBaseStyles = (0, $jvNZe$emotionreact.css)`
  display: inline-block;
  white-space: pre;
`;
const $c8a4d927fd00b892$export$9a32a8eb4bb56ca3 = (props)=>{
    const { cascade: cascade = false , damping: damping = 0.5 , delay: delay = 0 , duration: duration = 1000 , fraction: fraction = 0 , keyframes: keyframes = (0, $059dd4d1a0e7c5c8$export$d8fce5eeb232a07b) , triggerOnce: triggerOnce = false , css: revealCss , className: className , style: style , childClassName: childClassName , childStyle: childStyle , children: children , onVisibilityChange: onVisibilityChange ,  } = props;
    const animationStyles = (0, $jvNZe$react.useMemo)(()=>(0, $f2597d38a334a0ad$export$cdf1f51c52cf49d8)({
            keyframes: keyframes,
            duration: duration
        }), [
        duration,
        keyframes
    ]);
    if ((0, $6a26e8abc0402dd5$export$bedb7023a7733221)(children)) return null;
    if ((0, $6a26e8abc0402dd5$export$f832f653c73e86f8)(children)) return (0, $jvNZe$emotionreactjsxruntime.jsx)($c8a4d927fd00b892$var$TextReveal, {
        ...props,
        animationStyles: animationStyles,
        children: String(children)
    });
    if ((0, $jvNZe$reactis.isFragment)(children)) return (0, $jvNZe$emotionreactjsxruntime.jsx)($c8a4d927fd00b892$var$FragmentReveal, {
        ...props,
        animationStyles: animationStyles
    });
    return (0, $jvNZe$emotionreactjsxruntime.jsx)((0, $jvNZe$emotionreactjsxruntime.Fragment), {
        children: (0, $jvNZe$react.Children).map(children, (node, index)=>{
            if (!/*#__PURE__*/ (0, $jvNZe$react.isValidElement)(node)) return null;
            const inViewStyles = [
                revealCss,
                animationStyles
            ];
            const nodeDelay = delay + (cascade ? index * duration * damping : 0);
            switch(node.type){
                case "ol":
                case "ul":
                    return (0, $jvNZe$emotionreactjsxruntime.jsx)((0, $jvNZe$emotionreact.ClassNames), {
                        children: ({ cx: cx  })=>(0, $jvNZe$emotionreactjsxruntime.jsx)(node.type, {
                                ...node.props,
                                className: cx(className, node.props.className),
                                style: {
                                    ...style,
                                    ...node.props.style
                                },
                                children: (0, $jvNZe$emotionreactjsxruntime.jsx)($c8a4d927fd00b892$export$9a32a8eb4bb56ca3, {
                                    ...props,
                                    children: node.props.children
                                })
                            })
                    });
                case "li":
                    return (0, $jvNZe$emotionreactjsxruntime.jsx)((0, $jvNZe$reactintersectionobserver.InView), {
                        threshold: fraction,
                        triggerOnce: triggerOnce,
                        onChange: onVisibilityChange,
                        children: ({ inView: inView , ref: ref  })=>(0, $jvNZe$emotionreactjsxruntime.jsx)((0, $jvNZe$emotionreact.ClassNames), {
                                children: ({ cx: cx  })=>(0, $jvNZe$emotionreactjsxruntime.jsx)(node.type, {
                                        ...node.props,
                                        ref: ref,
                                        className: cx(childClassName, node.props.className),
                                        css: inView ? inViewStyles : $c8a4d927fd00b892$var$hiddenStyles,
                                        style: {
                                            ...childStyle,
                                            ...node.props.style,
                                            animationDelay: nodeDelay + "ms"
                                        }
                                    })
                            })
                    });
                default:
                    return (0, $jvNZe$emotionreactjsxruntime.jsx)((0, $jvNZe$reactintersectionobserver.InView), {
                        threshold: fraction,
                        triggerOnce: triggerOnce,
                        onChange: onVisibilityChange,
                        children: ({ inView: inView , ref: ref  })=>(0, $jvNZe$emotionreactjsxruntime.jsx)("div", {
                                ref: ref,
                                className: className,
                                css: inView ? inViewStyles : $c8a4d927fd00b892$var$hiddenStyles,
                                style: {
                                    ...style,
                                    animationDelay: nodeDelay + "ms"
                                },
                                children: (0, $jvNZe$emotionreactjsxruntime.jsx)((0, $jvNZe$emotionreact.ClassNames), {
                                    children: ({ cx: cx  })=>(0, $jvNZe$emotionreactjsxruntime.jsx)(node.type, {
                                            ...node.props,
                                            className: cx(childClassName, node.props.className),
                                            style: {
                                                ...childStyle,
                                                ...node.props.style
                                            }
                                        })
                                })
                            })
                    });
            }
        })
    });
};
const $c8a4d927fd00b892$var$TextReveal = (props)=>{
    const { animationStyles: animationStyles , cascade: cascade = false , damping: damping = 0.5 , delay: delay = 0 , duration: duration = 1000 , fraction: fraction = 0 , triggerOnce: triggerOnce = false , css: revealCss , className: className , style: style , children: children , onVisibilityChange: onVisibilityChange ,  } = props;
    const { ref: ref , inView: inView  } = (0, $jvNZe$reactintersectionobserver.useInView)({
        triggerOnce: triggerOnce,
        threshold: fraction,
        onChange: onVisibilityChange
    });
    return cascade ? (0, $jvNZe$emotionreactjsxruntime.jsx)("div", {
        ref: ref,
        className: className,
        css: [
            revealCss,
            $c8a4d927fd00b892$var$textBaseStyles
        ],
        style: style,
        children: children.split("").map((char, index)=>(0, $jvNZe$emotionreactjsxruntime.jsx)("span", {
                css: inView ? animationStyles : $c8a4d927fd00b892$var$hiddenStyles,
                style: {
                    animationDelay: delay + index * duration * damping + "ms"
                },
                children: char
            }, index))
    }) : (0, $jvNZe$emotionreactjsxruntime.jsx)($c8a4d927fd00b892$var$FragmentReveal, {
        ...props,
        children: children
    });
};
const $c8a4d927fd00b892$var$FragmentReveal = (props)=>{
    const { animationStyles: animationStyles , fraction: fraction = 0 , triggerOnce: triggerOnce = false , css: revealCss , className: className , style: style , children: children , onVisibilityChange: onVisibilityChange ,  } = props;
    const { ref: ref , inView: inView  } = (0, $jvNZe$reactintersectionobserver.useInView)({
        triggerOnce: triggerOnce,
        threshold: fraction,
        onChange: onVisibilityChange
    });
    const inViewStyles = [
        revealCss,
        animationStyles
    ];
    return (0, $jvNZe$emotionreactjsxruntime.jsx)("div", {
        ref: ref,
        className: className,
        css: inView ? inViewStyles : $c8a4d927fd00b892$var$hiddenStyles,
        style: style,
        children: children
    });
};


function $53b8ad22b050830b$var$getStyles(effect) {
    switch(effect){
        case "flash":
            return [
                (0, $fd9067391ce6df13$export$fff9462e59a6c087)
            ];
        case "headShake":
            return [
                (0, $eb9167f8b04a1eef$export$cc718fa79617014c),
                {
                    animationTimingFunction: "ease-in-out"
                }
            ];
        case "heartBeat":
            return [
                (0, $6efeb5b76066380c$export$f5767cd4e86f63a5),
                {
                    animationTimingFunction: "ease-in-out"
                }
            ];
        case "jello":
            return [
                (0, $bbf7c8c1f2f8bcda$export$821f6a9282d0ec8d),
                {
                    transformOrigin: "center"
                }
            ];
        case "pulse":
            return [
                (0, $409347824bf28b80$export$f3aaf94dc96a60de),
                {
                    animationTimingFunction: "ease-in-out"
                }
            ];
        case "rubberBand":
            return [
                (0, $118273709ecc7996$export$bbc07f6a19d55e88)
            ];
        case "shake":
            return [
                (0, $99597785e49dcbea$export$267b06a7460aa7d3)
            ];
        case "shakeX":
            return [
                (0, $5dd42df0435d852f$export$8e99d6962f95c405)
            ];
        case "shakeY":
            return [
                (0, $ef91eb5bdfc318f0$export$8c0595fc0dd256ce)
            ];
        case "swing":
            return [
                (0, $17cad7ed79df0fbf$export$84fc4030631e573c),
                {
                    transformOrigin: "top center"
                }
            ];
        case "tada":
            return [
                (0, $cb5eed64c434fe13$export$1362d96c12095304)
            ];
        case "wobble":
            return [
                (0, $64e244b1100f4aec$export$138a91d3335be56)
            ];
        case "bounce":
        default:
            return [
                (0, $88ffd68ae302398a$export$e3ce947fb98643bf),
                {
                    transformOrigin: "center bottom"
                }
            ];
    }
}
const $53b8ad22b050830b$export$1736648c5c27c79d = (props)=>{
    const { effect: effect = "bounce" , ...rest } = props;
    const [keyframes, animationCss] = (0, $jvNZe$react.useMemo)(()=>$53b8ad22b050830b$var$getStyles(effect), [
        effect
    ]);
    return (0, $jvNZe$emotionreactjsxruntime.jsx)((0, $c8a4d927fd00b892$export$9a32a8eb4bb56ca3), {
        keyframes: keyframes,
        css: animationCss,
        ...rest
    });
};


var $538f81368e1b5055$exports = {};

$parcel$export($538f81368e1b5055$exports, "Bounce", () => $538f81368e1b5055$export$d20e79fdc3899e95);



const $239280df9946b122$export$fccebd7948554554 = (0, $jvNZe$emotionreact.keyframes)`
  from,
  20%,
  40%,
  60%,
  80%,
  to {
    animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
  }

  0% {
    opacity: 0;
    transform: scale3d(0.3, 0.3, 0.3);
  }

  20% {
    transform: scale3d(1.1, 1.1, 1.1);
  }

  40% {
    transform: scale3d(0.9, 0.9, 0.9);
  }

  60% {
    opacity: 1;
    transform: scale3d(1.03, 1.03, 1.03);
  }

  80% {
    transform: scale3d(0.97, 0.97, 0.97);
  }

  to {
    opacity: 1;
    transform: scale3d(1, 1, 1);
  }
`;


const $6cf6d8e43927ecb0$export$5567dcc4c3474880 = (0, $jvNZe$emotionreact.keyframes)`
  from,
  60%,
  75%,
  90%,
  to {
    animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
  }

  0% {
    opacity: 0;
    transform: translate3d(0, -3000px, 0) scaleY(3);
  }

  60% {
    opacity: 1;
    transform: translate3d(0, 25px, 0) scaleY(0.9);
  }

  75% {
    transform: translate3d(0, -10px, 0) scaleY(0.95);
  }

  90% {
    transform: translate3d(0, 5px, 0) scaleY(0.985);
  }

  to {
    transform: translate3d(0, 0, 0);
  }
`;


const $5c0cd9513f5655ae$export$92fd46a1c9da5ead = (0, $jvNZe$emotionreact.keyframes)`
  from,
  60%,
  75%,
  90%,
  to {
    animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
  }

  0% {
    opacity: 0;
    transform: translate3d(-3000px, 0, 0) scaleX(3);
  }

  60% {
    opacity: 1;
    transform: translate3d(25px, 0, 0) scaleX(1);
  }

  75% {
    transform: translate3d(-10px, 0, 0) scaleX(0.98);
  }

  90% {
    transform: translate3d(5px, 0, 0) scaleX(0.995);
  }

  to {
    transform: translate3d(0, 0, 0);
  }
`;


const $9fc2107612a180c2$export$aebe35d18555813a = (0, $jvNZe$emotionreact.keyframes)`
  from,
  60%,
  75%,
  90%,
  to {
    animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
  }

  from {
    opacity: 0;
    transform: translate3d(3000px, 0, 0) scaleX(3);
  }

  60% {
    opacity: 1;
    transform: translate3d(-25px, 0, 0) scaleX(1);
  }

  75% {
    transform: translate3d(10px, 0, 0) scaleX(0.98);
  }

  90% {
    transform: translate3d(-5px, 0, 0) scaleX(0.995);
  }

  to {
    transform: translate3d(0, 0, 0);
  }
`;


const $df2aa9ffda66bf8e$export$9e7bc32a82042281 = (0, $jvNZe$emotionreact.keyframes)`
  from,
  60%,
  75%,
  90%,
  to {
    animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
  }

  from {
    opacity: 0;
    transform: translate3d(0, 3000px, 0) scaleY(5);
  }

  60% {
    opacity: 1;
    transform: translate3d(0, -20px, 0) scaleY(0.9);
  }

  75% {
    transform: translate3d(0, 10px, 0) scaleY(0.95);
  }

  90% {
    transform: translate3d(0, -5px, 0) scaleY(0.985);
  }

  to {
    transform: translate3d(0, 0, 0);
  }
`;




const $279e1b37c9d3b420$export$cccc9e04465dce11 = (0, $jvNZe$emotionreact.keyframes)`
  20% {
    transform: scale3d(0.9, 0.9, 0.9);
  }

  50%,
  55% {
    opacity: 1;
    transform: scale3d(1.1, 1.1, 1.1);
  }

  to {
    opacity: 0;
    transform: scale3d(0.3, 0.3, 0.3);
  }
`;


const $c087b0b0bb8754b6$export$26ce0cf84248400c = (0, $jvNZe$emotionreact.keyframes)`
  20% {
    transform: translate3d(0, 10px, 0) scaleY(0.985);
  }

  40%,
  45% {
    opacity: 1;
    transform: translate3d(0, -20px, 0) scaleY(0.9);
  }

  to {
    opacity: 0;
    transform: translate3d(0, 2000px, 0) scaleY(3);
  }
`;


const $2d05960b7dd695c1$export$3dabd2f5ee26f898 = (0, $jvNZe$emotionreact.keyframes)`
  20% {
    opacity: 1;
    transform: translate3d(20px, 0, 0) scaleX(0.9);
  }

  to {
    opacity: 0;
    transform: translate3d(-2000px, 0, 0) scaleX(2);
  }
`;


const $6e8a1f82929c5a87$export$7b4a033090b713a = (0, $jvNZe$emotionreact.keyframes)`
  20% {
    opacity: 1;
    transform: translate3d(-20px, 0, 0) scaleX(0.9);
  }

  to {
    opacity: 0;
    transform: translate3d(2000px, 0, 0) scaleX(2);
  }
`;


const $ffd8976020fae4b5$export$fe9810e7e30c9caa = (0, $jvNZe$emotionreact.keyframes)`
  20% {
    transform: translate3d(0, -10px, 0) scaleY(0.985);
  }

  40%,
  45% {
    opacity: 1;
    transform: translate3d(0, 20px, 0) scaleY(0.9);
  }

  to {
    opacity: 0;
    transform: translate3d(0, -2000px, 0) scaleY(3);
  }
`;




function $538f81368e1b5055$var$getStyles(reverse, direction) {
    switch(direction){
        case "down":
            return reverse ? (0, $c087b0b0bb8754b6$export$26ce0cf84248400c) : (0, $6cf6d8e43927ecb0$export$5567dcc4c3474880);
        case "left":
            return reverse ? (0, $2d05960b7dd695c1$export$3dabd2f5ee26f898) : (0, $5c0cd9513f5655ae$export$92fd46a1c9da5ead);
        case "right":
            return reverse ? (0, $6e8a1f82929c5a87$export$7b4a033090b713a) : (0, $9fc2107612a180c2$export$aebe35d18555813a);
        case "up":
            return reverse ? (0, $ffd8976020fae4b5$export$fe9810e7e30c9caa) : (0, $df2aa9ffda66bf8e$export$9e7bc32a82042281);
        default:
            return reverse ? (0, $279e1b37c9d3b420$export$cccc9e04465dce11) : (0, $239280df9946b122$export$fccebd7948554554);
    }
}
const $538f81368e1b5055$export$d20e79fdc3899e95 = (props)=>{
    const { direction: direction , reverse: reverse = false , ...rest } = props;
    const keyframes = (0, $jvNZe$react.useMemo)(()=>$538f81368e1b5055$var$getStyles(reverse, direction), [
        direction,
        reverse
    ]);
    return (0, $jvNZe$emotionreactjsxruntime.jsx)((0, $c8a4d927fd00b892$export$9a32a8eb4bb56ca3), {
        keyframes: keyframes,
        ...rest
    });
};


var $38e0da7e8ca22f50$exports = {};

$parcel$export($38e0da7e8ca22f50$exports, "Fade", () => $38e0da7e8ca22f50$export$c983850c6c9d8b0e);




const $a785dbac738f5f3e$export$c091916f1530334c = (0, $jvNZe$emotionreact.keyframes)`
  from {
    opacity: 1;
  }

  to {
    opacity: 0;
  }
`;


const $ce011eac9ce0614a$export$19a945979f1fb3dc = (0, $jvNZe$emotionreact.keyframes)`
  from {
    opacity: 1;
    transform: translate3d(0, 0, 0);
  }

  to {
    opacity: 0;
    transform: translate3d(-100%, 100%, 0);
  }
`;


const $c2858a61175e3532$export$5728b370175ac481 = (0, $jvNZe$emotionreact.keyframes)`
  from {
    opacity: 1;
    transform: translate3d(0, 0, 0);
  }

  to {
    opacity: 0;
    transform: translate3d(100%, 100%, 0);
  }
`;


const $0e2ef080f367183e$export$918ddd2a9d66b46e = (0, $jvNZe$emotionreact.keyframes)`
  from {
    opacity: 1;
  }

  to {
    opacity: 0;
    transform: translate3d(0, 100%, 0);
  }
`;


const $d7fb8c5deff36398$export$658ef65a86bafcbd = (0, $jvNZe$emotionreact.keyframes)`
  from {
    opacity: 1;
  }

  to {
    opacity: 0;
    transform: translate3d(0, 2000px, 0);
  }
`;


const $d1a858cda71a4e75$export$99efea88984e567e = (0, $jvNZe$emotionreact.keyframes)`
  from {
    opacity: 1;
  }

  to {
    opacity: 0;
    transform: translate3d(-100%, 0, 0);
  }
`;


const $95af0635245b07a1$export$3a9dc8f9529ceff5 = (0, $jvNZe$emotionreact.keyframes)`
  from {
    opacity: 1;
  }

  to {
    opacity: 0;
    transform: translate3d(-2000px, 0, 0);
  }
`;


const $1ce7d5ebbf024e25$export$1541972369870d64 = (0, $jvNZe$emotionreact.keyframes)`
  from {
    opacity: 1;
  }

  to {
    opacity: 0;
    transform: translate3d(100%, 0, 0);
  }
`;


const $98c2de600df5e876$export$d3f8667912a1aaa1 = (0, $jvNZe$emotionreact.keyframes)`
  from {
    opacity: 1;
  }

  to {
    opacity: 0;
    transform: translate3d(2000px, 0, 0);
  }
`;


const $f86363e7f17f6b48$export$cc0980c21917f2b0 = (0, $jvNZe$emotionreact.keyframes)`
  from {
    opacity: 1;
    transform: translate3d(0, 0, 0);
  }

  to {
    opacity: 0;
    transform: translate3d(-100%, -100%, 0);
  }
`;


const $a0fce7756a006a41$export$510f794173174a8b = (0, $jvNZe$emotionreact.keyframes)`
  from {
    opacity: 1;
    transform: translate3d(0, 0, 0);
  }

  to {
    opacity: 0;
    transform: translate3d(100%, -100%, 0);
  }
`;


const $41ae82f5230c6f3d$export$4163084011e71929 = (0, $jvNZe$emotionreact.keyframes)`
  from {
    opacity: 1;
  }

  to {
    opacity: 0;
    transform: translate3d(0, -100%, 0);
  }
`;


const $620ee1fbd37ce3b0$export$b0540367e09512e9 = (0, $jvNZe$emotionreact.keyframes)`
  from {
    opacity: 1;
  }

  to {
    opacity: 0;
    transform: translate3d(0, -2000px, 0);
  }
`;




function $38e0da7e8ca22f50$var$getStyles(big, reverse, direction) {
    switch(direction){
        case "bottom-left":
            return reverse ? (0, $ce011eac9ce0614a$export$19a945979f1fb3dc) : (0, $5d24f5d06eb0ca64$export$27e0c58916e1badc);
        case "bottom-right":
            return reverse ? (0, $c2858a61175e3532$export$5728b370175ac481) : (0, $2a57c406215d34eb$export$f72096766ea3a089);
        case "down":
            return big ? reverse ? (0, $d7fb8c5deff36398$export$658ef65a86bafcbd) : (0, $993b4f2eec647e23$export$aa45f1f50300a7c0) : reverse ? (0, $0e2ef080f367183e$export$918ddd2a9d66b46e) : (0, $568a146f8f1dc468$export$6ecdcdb0033d0327);
        case "left":
            return big ? reverse ? (0, $95af0635245b07a1$export$3a9dc8f9529ceff5) : (0, $e77687a7cf911846$export$327c6b58e5f59d6f) : reverse ? (0, $d1a858cda71a4e75$export$99efea88984e567e) : (0, $059dd4d1a0e7c5c8$export$d8fce5eeb232a07b);
        case "right":
            return big ? reverse ? (0, $98c2de600df5e876$export$d3f8667912a1aaa1) : (0, $55cf3d076c695f42$export$6f5ccd79656f671) : reverse ? (0, $1ce7d5ebbf024e25$export$1541972369870d64) : (0, $f128273212bfa795$export$7b78ca149b3ffe20);
        case "top-left":
            return reverse ? (0, $f86363e7f17f6b48$export$cc0980c21917f2b0) : (0, $156b763c5e69a9ca$export$777354dbc7828ff3);
        case "top-right":
            return reverse ? (0, $a0fce7756a006a41$export$510f794173174a8b) : (0, $694098d2b7aee85e$export$d5bfa04a6ce7104f);
        case "up":
            return big ? reverse ? (0, $620ee1fbd37ce3b0$export$b0540367e09512e9) : (0, $0cf1b8b22f8c2075$export$f18a2356a26ed325) : reverse ? (0, $41ae82f5230c6f3d$export$4163084011e71929) : (0, $b15cf9ee005e2158$export$546bb2e31f381a81);
        default:
            return reverse ? (0, $a785dbac738f5f3e$export$c091916f1530334c) : (0, $9ea0f43f56ccecde$export$82e6205b15e6c637);
    }
}
const $38e0da7e8ca22f50$export$c983850c6c9d8b0e = (props)=>{
    const { big: big = false , direction: direction , reverse: reverse = false , ...rest } = props;
    const keyframes = (0, $jvNZe$react.useMemo)(()=>$38e0da7e8ca22f50$var$getStyles(big, reverse, direction), [
        big,
        direction,
        reverse
    ]);
    return (0, $jvNZe$emotionreactjsxruntime.jsx)((0, $c8a4d927fd00b892$export$9a32a8eb4bb56ca3), {
        keyframes: keyframes,
        ...rest
    });
};


var $a24d7b7f95c41c0b$exports = {};

$parcel$export($a24d7b7f95c41c0b$exports, "Flip", () => $a24d7b7f95c41c0b$export$4d2fae537bd90431);




const $7a93ca27322ab527$export$8a83211c878a3f1f = (0, $jvNZe$emotionreact.keyframes)`
  from {
    transform: perspective(400px) scale3d(1, 1, 1) translate3d(0, 0, 0) rotate3d(0, 1, 0, -360deg);
    animation-timing-function: ease-out;
  }

  40% {
    transform: perspective(400px) scale3d(1, 1, 1) translate3d(0, 0, 150px)
      rotate3d(0, 1, 0, -190deg);
    animation-timing-function: ease-out;
  }

  50% {
    transform: perspective(400px) scale3d(1, 1, 1) translate3d(0, 0, 150px)
      rotate3d(0, 1, 0, -170deg);
    animation-timing-function: ease-in;
  }

  80% {
    transform: perspective(400px) scale3d(0.95, 0.95, 0.95) translate3d(0, 0, 0)
      rotate3d(0, 1, 0, 0deg);
    animation-timing-function: ease-in;
  }

  to {
    transform: perspective(400px) scale3d(1, 1, 1) translate3d(0, 0, 0) rotate3d(0, 1, 0, 0deg);
    animation-timing-function: ease-in;
  }
`;


const $f9190ee81e2d4988$export$68ed1a067f792190 = (0, $jvNZe$emotionreact.keyframes)`
  from {
    transform: perspective(400px) rotate3d(1, 0, 0, 90deg);
    animation-timing-function: ease-in;
    opacity: 0;
  }

  40% {
    transform: perspective(400px) rotate3d(1, 0, 0, -20deg);
    animation-timing-function: ease-in;
  }

  60% {
    transform: perspective(400px) rotate3d(1, 0, 0, 10deg);
    opacity: 1;
  }

  80% {
    transform: perspective(400px) rotate3d(1, 0, 0, -5deg);
  }

  to {
    transform: perspective(400px);
  }
`;


const $305856451e6f8fcc$export$a10221d4eadc810 = (0, $jvNZe$emotionreact.keyframes)`
  from {
    transform: perspective(400px) rotate3d(0, 1, 0, 90deg);
    animation-timing-function: ease-in;
    opacity: 0;
  }

  40% {
    transform: perspective(400px) rotate3d(0, 1, 0, -20deg);
    animation-timing-function: ease-in;
  }

  60% {
    transform: perspective(400px) rotate3d(0, 1, 0, 10deg);
    opacity: 1;
  }

  80% {
    transform: perspective(400px) rotate3d(0, 1, 0, -5deg);
  }

  to {
    transform: perspective(400px);
  }
`;


const $86a1dd67c7624c85$export$4eaf247181cd9ec3 = (0, $jvNZe$emotionreact.keyframes)`
  from {
    transform: perspective(400px);
  }

  30% {
    transform: perspective(400px) rotate3d(1, 0, 0, -20deg);
    opacity: 1;
  }

  to {
    transform: perspective(400px) rotate3d(1, 0, 0, 90deg);
    opacity: 0;
  }
`;


const $6bb13209ce33d395$export$93f09c73becb5407 = (0, $jvNZe$emotionreact.keyframes)`
  from {
    transform: perspective(400px);
  }

  30% {
    transform: perspective(400px) rotate3d(0, 1, 0, -15deg);
    opacity: 1;
  }

  to {
    transform: perspective(400px) rotate3d(0, 1, 0, 90deg);
    opacity: 0;
  }
`;




function $a24d7b7f95c41c0b$var$getStyles(reverse, direction) {
    switch(direction){
        case "horizontal":
            return reverse ? (0, $86a1dd67c7624c85$export$4eaf247181cd9ec3) : (0, $f9190ee81e2d4988$export$68ed1a067f792190);
        case "vertical":
            return reverse ? (0, $6bb13209ce33d395$export$93f09c73becb5407) : (0, $305856451e6f8fcc$export$a10221d4eadc810);
        default:
            return 0, $7a93ca27322ab527$export$8a83211c878a3f1f;
    }
}
const $a24d7b7f95c41c0b$var$animationCss = (0, $jvNZe$emotionreact.css)`
  backface-visibility: visible;
`;
const $a24d7b7f95c41c0b$export$4d2fae537bd90431 = (props)=>{
    const { direction: direction , reverse: reverse = false , ...rest } = props;
    const keyframes = (0, $jvNZe$react.useMemo)(()=>$a24d7b7f95c41c0b$var$getStyles(reverse, direction), [
        direction,
        reverse
    ]);
    return (0, $jvNZe$emotionreactjsxruntime.jsx)((0, $c8a4d927fd00b892$export$9a32a8eb4bb56ca3), {
        css: $a24d7b7f95c41c0b$var$animationCss,
        keyframes: keyframes,
        ...rest
    });
};


var $ba126b9772ca94c1$exports = {};

$parcel$export($ba126b9772ca94c1$exports, "Hinge", () => $ba126b9772ca94c1$export$51b1a342f43475b0);



const $d5624047c6cd5156$export$321a3d0bf2c75 = (0, $jvNZe$emotionreact.keyframes)`
  0% {
    animation-timing-function: ease-in-out;
  }

  20%,
  60% {
    transform: rotate3d(0, 0, 1, 80deg);
    animation-timing-function: ease-in-out;
  }

  40%,
  80% {
    transform: rotate3d(0, 0, 1, 60deg);
    animation-timing-function: ease-in-out;
    opacity: 1;
  }

  to {
    transform: translate3d(0, 700px, 0);
    opacity: 0;
  }
`;


const $763e7a71060b44ee$export$51046d36a99b73b0 = (0, $jvNZe$emotionreact.keyframes)`
  from {
    opacity: 0;
    transform: scale(0.1) rotate(30deg);
    transform-origin: center bottom;
  }

  50% {
    transform: rotate(-10deg);
  }

  70% {
    transform: rotate(3deg);
  }

  to {
    opacity: 1;
    transform: scale(1);
  }
`;


const $a5c6d470e6bb1934$export$6aa1850093220a4f = (0, $jvNZe$emotionreact.keyframes)`
  from {
    opacity: 0;
    transform: translate3d(-100%, 0, 0) rotate3d(0, 0, 1, -120deg);
  }

  to {
    opacity: 1;
    transform: translate3d(0, 0, 0);
  }
`;


const $a7e54697faae7be6$export$e78f98b32413b70e = (0, $jvNZe$emotionreact.keyframes)`
  from {
    opacity: 1;
  }

  to {
    opacity: 0;
    transform: translate3d(100%, 0, 0) rotate3d(0, 0, 1, 120deg);
  }
`;




const $ba126b9772ca94c1$var$animationCss = (0, $jvNZe$emotionreact.css)`
  transform-origin: top left;
`;
const $ba126b9772ca94c1$export$51b1a342f43475b0 = (props)=>{
    return (0, $jvNZe$emotionreactjsxruntime.jsx)((0, $c8a4d927fd00b892$export$9a32a8eb4bb56ca3), {
        css: $ba126b9772ca94c1$var$animationCss,
        keyframes: (0, $d5624047c6cd5156$export$321a3d0bf2c75),
        ...props
    });
};


var $5923581cb4748dcc$exports = {};

$parcel$export($5923581cb4748dcc$exports, "JackInTheBox", () => $5923581cb4748dcc$export$2d9d44ff5c623255);



const $5923581cb4748dcc$export$2d9d44ff5c623255 = (props)=>{
    return (0, $jvNZe$emotionreactjsxruntime.jsx)((0, $c8a4d927fd00b892$export$9a32a8eb4bb56ca3), {
        keyframes: (0, $763e7a71060b44ee$export$51046d36a99b73b0),
        ...props
    });
};


var $9e09e3efd7b75ad7$exports = {};

$parcel$export($9e09e3efd7b75ad7$exports, "Roll", () => $9e09e3efd7b75ad7$export$aa11096b70371f74);




function $9e09e3efd7b75ad7$var$getStyles(reverse) {
    return reverse ? (0, $a7e54697faae7be6$export$e78f98b32413b70e) : (0, $a5c6d470e6bb1934$export$6aa1850093220a4f);
}
const $9e09e3efd7b75ad7$export$aa11096b70371f74 = (props)=>{
    const { reverse: reverse = false , ...rest } = props;
    const keyframes = (0, $jvNZe$react.useMemo)(()=>$9e09e3efd7b75ad7$var$getStyles(reverse), [
        reverse
    ]);
    return (0, $jvNZe$emotionreactjsxruntime.jsx)((0, $c8a4d927fd00b892$export$9a32a8eb4bb56ca3), {
        keyframes: keyframes,
        ...rest
    });
};


var $f25af1ae851295d5$exports = {};

$parcel$export($f25af1ae851295d5$exports, "Rotate", () => $f25af1ae851295d5$export$152db69a76b6b79e);



const $1b29b037584a02bc$export$2b9048e0715456a4 = (0, $jvNZe$emotionreact.keyframes)`
  from {
    transform: rotate3d(0, 0, 1, -200deg);
    opacity: 0;
  }

  to {
    transform: translate3d(0, 0, 0);
    opacity: 1;
  }
`;


const $6d158bf4c3b9a085$export$7336503083b51ac8 = (0, $jvNZe$emotionreact.keyframes)`
  from {
    transform: rotate3d(0, 0, 1, -45deg);
    opacity: 0;
  }

  to {
    transform: translate3d(0, 0, 0);
    opacity: 1;
  }
`;


const $8088f56d0f185f82$export$d39468e8ba1f782c = (0, $jvNZe$emotionreact.keyframes)`
  from {
    transform: rotate3d(0, 0, 1, 45deg);
    opacity: 0;
  }

  to {
    transform: translate3d(0, 0, 0);
    opacity: 1;
  }
`;


const $6989a54600cd1b06$export$3848addc86cdb49f = (0, $jvNZe$emotionreact.keyframes)`
  from {
    transform: rotate3d(0, 0, 1, 45deg);
    opacity: 0;
  }

  to {
    transform: translate3d(0, 0, 0);
    opacity: 1;
  }
`;


const $15ca95aca9bd2baa$export$bb10501f1250224d = (0, $jvNZe$emotionreact.keyframes)`
  from {
    transform: rotate3d(0, 0, 1, -90deg);
    opacity: 0;
  }

  to {
    transform: translate3d(0, 0, 0);
    opacity: 1;
  }
`;




const $95a219812d2befe1$export$5e1ccc268ae376b0 = (0, $jvNZe$emotionreact.keyframes)`
  from {
    opacity: 1;
  }

  to {
    transform: rotate3d(0, 0, 1, 200deg);
    opacity: 0;
  }
`;


const $3c1382ebe584e541$export$fb5eb9e37db0dfef = (0, $jvNZe$emotionreact.keyframes)`
  from {
    opacity: 1;
  }

  to {
    transform: rotate3d(0, 0, 1, 45deg);
    opacity: 0;
  }
`;


const $87e525313846a8f0$export$638177b843431394 = (0, $jvNZe$emotionreact.keyframes)`
  from {
    opacity: 1;
  }

  to {
    transform: rotate3d(0, 0, 1, -45deg);
    opacity: 0;
  }
`;


const $5552c563ee00b4ba$export$d921b7e0db7ff86e = (0, $jvNZe$emotionreact.keyframes)`
  from {
    opacity: 1;
  }

  to {
    transform: rotate3d(0, 0, 1, -45deg);
    opacity: 0;
  }
`;


const $16fb611719275541$export$43ebaa489dfc2f5d = (0, $jvNZe$emotionreact.keyframes)`
  from {
    opacity: 1;
  }

  to {
    transform: rotate3d(0, 0, 1, 90deg);
    opacity: 0;
  }
`;




function $f25af1ae851295d5$var$getStyles(reverse, direction) {
    switch(direction){
        case "bottom-left":
            return reverse ? [
                (0, $3c1382ebe584e541$export$fb5eb9e37db0dfef),
                {
                    transformOrigin: "left bottom"
                }
            ] : [
                (0, $6d158bf4c3b9a085$export$7336503083b51ac8),
                {
                    transformOrigin: "left bottom"
                }
            ];
        case "bottom-right":
            return reverse ? [
                (0, $87e525313846a8f0$export$638177b843431394),
                {
                    transformOrigin: "right bottom"
                }
            ] : [
                (0, $8088f56d0f185f82$export$d39468e8ba1f782c),
                {
                    transformOrigin: "right bottom"
                }
            ];
        case "top-left":
            return reverse ? [
                (0, $5552c563ee00b4ba$export$d921b7e0db7ff86e),
                {
                    transformOrigin: "left bottom"
                }
            ] : [
                (0, $6989a54600cd1b06$export$3848addc86cdb49f),
                {
                    transformOrigin: "left bottom"
                }
            ];
        case "top-right":
            return reverse ? [
                (0, $16fb611719275541$export$43ebaa489dfc2f5d),
                {
                    transformOrigin: "right bottom"
                }
            ] : [
                (0, $15ca95aca9bd2baa$export$bb10501f1250224d),
                {
                    transformOrigin: "right bottom"
                }
            ];
        default:
            return reverse ? [
                (0, $95a219812d2befe1$export$5e1ccc268ae376b0),
                {
                    transformOrigin: "center"
                }
            ] : [
                (0, $1b29b037584a02bc$export$2b9048e0715456a4),
                {
                    transformOrigin: "center"
                }
            ];
    }
}
const $f25af1ae851295d5$export$152db69a76b6b79e = (props)=>{
    const { direction: direction , reverse: reverse = false , ...rest } = props;
    const [keyframes, animationCss] = (0, $jvNZe$react.useMemo)(()=>$f25af1ae851295d5$var$getStyles(reverse, direction), [
        direction,
        reverse
    ]);
    return (0, $jvNZe$emotionreactjsxruntime.jsx)((0, $c8a4d927fd00b892$export$9a32a8eb4bb56ca3), {
        css: animationCss,
        keyframes: keyframes,
        ...rest
    });
};


var $f6faa87ecc5f38b3$exports = {};

$parcel$export($f6faa87ecc5f38b3$exports, "Slide", () => $f6faa87ecc5f38b3$export$d8dc01b5c85a37b9);



const $1af9db7d37d42750$export$8775e04aa1928f66 = (0, $jvNZe$emotionreact.keyframes)`
  from {
    transform: translate3d(0, -100%, 0);
    visibility: visible;
  }

  to {
    transform: translate3d(0, 0, 0);
  }
`;


const $83c671c42e55a388$export$8da96f801aa19ebe = (0, $jvNZe$emotionreact.keyframes)`
  from {
    transform: translate3d(-100%, 0, 0);
    visibility: visible;
  }

  to {
    transform: translate3d(0, 0, 0);
  }
`;


const $a3c30b51c08a5fd5$export$706618d509d55167 = (0, $jvNZe$emotionreact.keyframes)`
  from {
    transform: translate3d(100%, 0, 0);
    visibility: visible;
  }

  to {
    transform: translate3d(0, 0, 0);
  }
`;


const $72d9e9426629a007$export$8ce8a09eb901d11 = (0, $jvNZe$emotionreact.keyframes)`
  from {
    transform: translate3d(0, 100%, 0);
    visibility: visible;
  }

  to {
    transform: translate3d(0, 0, 0);
  }
`;




const $a3e33ea8b70d329f$export$4d23096b87fa05f1 = (0, $jvNZe$emotionreact.keyframes)`
  from {
    transform: translate3d(0, 0, 0);
  }

  to {
    visibility: hidden;
    transform: translate3d(0, 100%, 0);
  }
`;


const $a74adedc9b195b9f$export$78e157c613296941 = (0, $jvNZe$emotionreact.keyframes)`
  from {
    transform: translate3d(0, 0, 0);
  }

  to {
    visibility: hidden;
    transform: translate3d(-100%, 0, 0);
  }
`;


const $e378f8605569fffa$export$45629ceb9412b813 = (0, $jvNZe$emotionreact.keyframes)`
  from {
    transform: translate3d(0, 0, 0);
  }

  to {
    visibility: hidden;
    transform: translate3d(100%, 0, 0);
  }
`;


const $026acf3f541549c5$export$341210899707327e = (0, $jvNZe$emotionreact.keyframes)`
  from {
    transform: translate3d(0, 0, 0);
  }

  to {
    visibility: hidden;
    transform: translate3d(0, -100%, 0);
  }
`;




function $f6faa87ecc5f38b3$var$getStyles(reverse, direction) {
    switch(direction){
        case "down":
            return reverse ? (0, $a3e33ea8b70d329f$export$4d23096b87fa05f1) : (0, $1af9db7d37d42750$export$8775e04aa1928f66);
        case "right":
            return reverse ? (0, $e378f8605569fffa$export$45629ceb9412b813) : (0, $a3c30b51c08a5fd5$export$706618d509d55167);
        case "up":
            return reverse ? (0, $026acf3f541549c5$export$341210899707327e) : (0, $72d9e9426629a007$export$8ce8a09eb901d11);
        case "left":
        default:
            return reverse ? (0, $a74adedc9b195b9f$export$78e157c613296941) : (0, $83c671c42e55a388$export$8da96f801aa19ebe);
    }
}
const $f6faa87ecc5f38b3$export$d8dc01b5c85a37b9 = (props)=>{
    const { direction: direction , reverse: reverse = false , ...rest } = props;
    const keyframes = (0, $jvNZe$react.useMemo)(()=>$f6faa87ecc5f38b3$var$getStyles(reverse, direction), [
        direction,
        reverse
    ]);
    return (0, $jvNZe$emotionreactjsxruntime.jsx)((0, $c8a4d927fd00b892$export$9a32a8eb4bb56ca3), {
        keyframes: keyframes,
        ...rest
    });
};


var $034268f68644a31d$exports = {};

$parcel$export($034268f68644a31d$exports, "Zoom", () => $034268f68644a31d$export$65cfd44a2050f99);



const $dc843673fdba933c$export$3b71758b3ed5255f = (0, $jvNZe$emotionreact.keyframes)`
  from {
    opacity: 0;
    transform: scale3d(0.3, 0.3, 0.3);
  }

  50% {
    opacity: 1;
  }
`;


const $0b42e7a53c517724$export$f1fb318c9f90bd9f = (0, $jvNZe$emotionreact.keyframes)`
  from {
    opacity: 0;
    transform: scale3d(0.1, 0.1, 0.1) translate3d(0, -1000px, 0);
    animation-timing-function: cubic-bezier(0.55, 0.055, 0.675, 0.19);
  }

  60% {
    opacity: 1;
    transform: scale3d(0.475, 0.475, 0.475) translate3d(0, 60px, 0);
    animation-timing-function: cubic-bezier(0.175, 0.885, 0.32, 1);
  }
`;


const $936eed8bd433459e$export$3b5491f6985de80 = (0, $jvNZe$emotionreact.keyframes)`
  from {
    opacity: 0;
    transform: scale3d(0.1, 0.1, 0.1) translate3d(-1000px, 0, 0);
    animation-timing-function: cubic-bezier(0.55, 0.055, 0.675, 0.19);
  }

  60% {
    opacity: 1;
    transform: scale3d(0.475, 0.475, 0.475) translate3d(10px, 0, 0);
    animation-timing-function: cubic-bezier(0.175, 0.885, 0.32, 1);
  }
`;


const $ceb2fe140eb0ceb1$export$6d68984f8269fb51 = (0, $jvNZe$emotionreact.keyframes)`
  from {
    opacity: 0;
    transform: scale3d(0.1, 0.1, 0.1) translate3d(1000px, 0, 0);
    animation-timing-function: cubic-bezier(0.55, 0.055, 0.675, 0.19);
  }

  60% {
    opacity: 1;
    transform: scale3d(0.475, 0.475, 0.475) translate3d(-10px, 0, 0);
    animation-timing-function: cubic-bezier(0.175, 0.885, 0.32, 1);
  }
`;


const $4ac9fc03a237a348$export$f8e431a03d821bd2 = (0, $jvNZe$emotionreact.keyframes)`
  from {
    opacity: 0;
    transform: scale3d(0.1, 0.1, 0.1) translate3d(0, 1000px, 0);
    animation-timing-function: cubic-bezier(0.55, 0.055, 0.675, 0.19);
  }

  60% {
    opacity: 1;
    transform: scale3d(0.475, 0.475, 0.475) translate3d(0, -60px, 0);
    animation-timing-function: cubic-bezier(0.175, 0.885, 0.32, 1);
  }
`;




const $d60fcabdd553050f$export$9fdb0a49c6b4b521 = (0, $jvNZe$emotionreact.keyframes)`
  from {
    opacity: 1;
  }

  50% {
    opacity: 0;
    transform: scale3d(0.3, 0.3, 0.3);
  }

  to {
    opacity: 0;
  }
`;


const $24a33ab629d9f63a$export$10deba13beba726f = (0, $jvNZe$emotionreact.keyframes)`
  40% {
    opacity: 1;
    transform: scale3d(0.475, 0.475, 0.475) translate3d(0, -60px, 0);
    animation-timing-function: cubic-bezier(0.55, 0.055, 0.675, 0.19);
  }

  to {
    opacity: 0;
    transform: scale3d(0.1, 0.1, 0.1) translate3d(0, 2000px, 0);
    animation-timing-function: cubic-bezier(0.175, 0.885, 0.32, 1);
  }
`;


const $a6ffe5eb8dcf9326$export$a897bc2790be434e = (0, $jvNZe$emotionreact.keyframes)`
  40% {
    opacity: 1;
    transform: scale3d(0.475, 0.475, 0.475) translate3d(42px, 0, 0);
  }

  to {
    opacity: 0;
    transform: scale(0.1) translate3d(-2000px, 0, 0);
  }
`;


const $62cd9c1d62e0c7bf$export$23fe0a856d31fa73 = (0, $jvNZe$emotionreact.keyframes)`
  40% {
    opacity: 1;
    transform: scale3d(0.475, 0.475, 0.475) translate3d(-42px, 0, 0);
  }

  to {
    opacity: 0;
    transform: scale(0.1) translate3d(2000px, 0, 0);
  }
`;


const $7ba775b3029ac26b$export$6c4c2ccf7a384b67 = (0, $jvNZe$emotionreact.keyframes)`
  40% {
    opacity: 1;
    transform: scale3d(0.475, 0.475, 0.475) translate3d(0, 60px, 0);
    animation-timing-function: cubic-bezier(0.55, 0.055, 0.675, 0.19);
  }

  to {
    opacity: 0;
    transform: scale3d(0.1, 0.1, 0.1) translate3d(0, -2000px, 0);
    animation-timing-function: cubic-bezier(0.175, 0.885, 0.32, 1);
  }
`;




function $034268f68644a31d$var$getStyles(reverse, direction) {
    switch(direction){
        case "down":
            return reverse ? (0, $24a33ab629d9f63a$export$10deba13beba726f) : (0, $0b42e7a53c517724$export$f1fb318c9f90bd9f);
        case "left":
            return reverse ? (0, $a6ffe5eb8dcf9326$export$a897bc2790be434e) : (0, $936eed8bd433459e$export$3b5491f6985de80);
        case "right":
            return reverse ? (0, $62cd9c1d62e0c7bf$export$23fe0a856d31fa73) : (0, $ceb2fe140eb0ceb1$export$6d68984f8269fb51);
        case "up":
            return reverse ? (0, $7ba775b3029ac26b$export$6c4c2ccf7a384b67) : (0, $4ac9fc03a237a348$export$f8e431a03d821bd2);
        default:
            return reverse ? (0, $d60fcabdd553050f$export$9fdb0a49c6b4b521) : (0, $dc843673fdba933c$export$3b71758b3ed5255f);
    }
}
const $034268f68644a31d$export$65cfd44a2050f99 = (props)=>{
    const { direction: direction , reverse: reverse = false , ...rest } = props;
    const keyframes = (0, $jvNZe$react.useMemo)(()=>$034268f68644a31d$var$getStyles(reverse, direction), [
        direction,
        reverse
    ]);
    return (0, $jvNZe$emotionreactjsxruntime.jsx)((0, $c8a4d927fd00b892$export$9a32a8eb4bb56ca3), {
        keyframes: keyframes,
        ...rest
    });
};


$parcel$exportWildcard($b60c6d4b91d2d5a9$exports, $53b8ad22b050830b$exports);
$parcel$exportWildcard($b60c6d4b91d2d5a9$exports, $538f81368e1b5055$exports);
$parcel$exportWildcard($b60c6d4b91d2d5a9$exports, $38e0da7e8ca22f50$exports);
$parcel$exportWildcard($b60c6d4b91d2d5a9$exports, $a24d7b7f95c41c0b$exports);
$parcel$exportWildcard($b60c6d4b91d2d5a9$exports, $ba126b9772ca94c1$exports);
$parcel$exportWildcard($b60c6d4b91d2d5a9$exports, $5923581cb4748dcc$exports);
$parcel$exportWildcard($b60c6d4b91d2d5a9$exports, $9e09e3efd7b75ad7$exports);
$parcel$exportWildcard($b60c6d4b91d2d5a9$exports, $f25af1ae851295d5$exports);
$parcel$exportWildcard($b60c6d4b91d2d5a9$exports, $f6faa87ecc5f38b3$exports);
$parcel$exportWildcard($b60c6d4b91d2d5a9$exports, $034268f68644a31d$exports);




$parcel$exportWildcard(module.exports, $b60c6d4b91d2d5a9$exports);
$parcel$exportWildcard(module.exports, $c8a4d927fd00b892$exports);


//# sourceMappingURL=main.js.map
